import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevronleft",
  "use": "chevronleft-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol viewBox=\"0 0 7 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevronleft\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.56066 2.79345C7.14645 2.15441 7.14645 1.11832 6.56066 0.47928C5.97487 -0.15976 5.02513 -0.15976 4.43934 0.47928L0.43934 4.84292C-0.146447 5.48196 -0.146447 6.51804 0.43934 7.15708L4.43934 11.5207C5.02513 12.1598 5.97487 12.1598 6.56066 11.5207C7.14645 10.8817 7.14645 9.84559 6.56066 9.20655L3.62132 6L6.56066 2.79345Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol